import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useEffect, useState } from 'react';
import { Button, Col, Justify, Row } from 'tea-component';
import { connect, useDispatch } from 'umi';
import { keyMetricsType } from '../../types/performance';
import MetricsCard from './MetricsCard';
import { dealwithNewOldData } from '@/pages/opinion/utils';

import NoDataCommon from '../../components/NoDataCommon';
import DownloadDialog from '@op/components/DownloadCommon/download-dialog';
import { downloadAction } from '../../components/DownloadCommon/download-page';
import LoadingCommon from '../../components/LoadingCommon';
import { dealwithArrayBrandHealth } from '@op/utils/value';

function Metrics(props: any) {
  const {
    userInfo,
    gameInfo,
    filter,
    filterOptions,
    keyMetrics,
    title,
    keyMetricsLoading = true,
  } = props;

  const dispatch = useDispatch();
  useEffect(() => {
    if (!userInfo || !gameInfo || !filter) return;

    dispatch({
      type: 'opinionPerformance/getOverviewKeyMetrics',
      payload: {
        ...filter,
        ...gameInfo,
        user_id: userInfo.userid,
        statistics_field: 'topic',
        need_link: true,
        metrics: [
          'net_sentiment',
          'mentions',
          'avg_sentiment',
          'engagement',
          'sentiment',
          'account_posts',
          gameInfo.entity_type === 'pc' ? 'selected_score' : 'user_score',
        ],
      },
    });
  }, [userInfo, filter]);

  const [downloadVisible, setDownloadVisible] = useState(false);

  // keyMetrics 数据处理

  let result: any = {};

  if (keyMetrics) {
    const sortKeyMetricsMap: {
      [key: string]: number;
    } = {
      mentions: 1,
      // account_posts: 2,
      engagement: 2,
      avg_sentiment: 3,
      brand_health: 4,
      non_negative_ratio: 5,
      user_score: 6,
      steam_selected_score: 6,
    };
    const keepKeyMetricsKeys = Object.keys(sortKeyMetricsMap);

    const { new_list, old_list, link_time: linkTime = {} } = keyMetrics || {};

    let newList = dealwithArrayBrandHealth(new_list);
    let oldList = dealwithArrayBrandHealth(old_list);
    newList = new_list
      ?.filter((item: any) => keepKeyMetricsKeys.includes(item.key))
      ?.sort(
        (a: any, b: any) => sortKeyMetricsMap[a.key] - sortKeyMetricsMap[b.key],
      );
    const key_metrics = dealwithNewOldData<{ key: string; value: number }>(
      newList,
      oldList,
      'key',
      ['value'],
      (newItem, oldItem) => ({
        metric_name: newItem.key,
        pre_value: oldItem?.value || 0,
      }),
      undefined,
      undefined,
      () => 'dod',
    );

    result = {
      key_metrics,
      time_period: {
        start_date: linkTime.new_start_date,
        end_date: linkTime.new_end_date,
        pre_start_date: linkTime.old_start_date,
        pre_end_date: linkTime.old_end_date,
      },
    };
  }

  // console.log('keyMetrics', props);

  return (
    <>
      <Justify
        className="dbo-performance-justify"
        left={
          <div className="dbo-performance-flex">
            <span className="title-text">{title}</span>
            <SvgIcon type="arrow-right" className="title-icon" />
          </div>
        }
        right={
          <Button
            icon="download"
            className="ns-btn--icon dbo-performance-download"
            title="下载"
            onClick={() => {
              setDownloadVisible(true);
            }}
          />
        }
      />
      <Row className="dbo-cardrow-wrap">
        {keyMetricsLoading ? (
          <LoadingCommon
            status="loading"
            style={{
              height: 140,
            }}
          ></LoadingCommon>
        ) : Array.isArray(result?.key_metrics) &&
          result?.key_metrics.length > 0 ? (
          result?.key_metrics?.map?.((item: keyMetricsType) => (
            <Col span={4} key={item.metric_name}>
              <MetricsCard
                time_period={result.time_period}
                data={item}
                gameInfo={gameInfo}
                filter={filter}
              />
            </Col>
          ))
        ) : (
          <NoDataCommon hasDesc style={{ height: 140 }}></NoDataCommon>
        )}

        {}
      </Row>

      <DownloadDialog
        visible={downloadVisible}
        setVisible={setDownloadVisible}
        download={(params: any) => {
          console.log('download metrics', params);
          const { accumulation, metrics } = params;
          const group_bys: Array<string> = [];
          const keyMap: any = {
            by_channel: 'channel',
            by_country: 'country',
            by_date: 'time',
            by_language: 'language',
            by_sentiment: 'sentiment',
            // by_net_sentiment: 'net_sentiment',
            by_rating: 'rating',
          };
          for (const key in accumulation) {
            const element = accumulation[key];
            if (element) {
              group_bys.push(keyMap[key]);
            }
          }
          const metricsMap: any = {
            Mentions: 'mentions',
            'Account Post': 'account_posts',
            Engagement: 'engagement',
            Sentiment: 'avg_sentiment',
            'Brand Health': 'brand_health',
            'Non Negative%': 'non_negative_ratio',
            'User Score': 'user_score',
          };

          downloadAction({
            simpleName: metrics?.join('_'),
            sheetName: 'Key Metrics',
            align: 'center',
            downLoadParams: {
              ...filter,
              ...gameInfo,
              metrics: metrics.map((item: string | number) => metricsMap[item]),
              group_bys,
            },
            downloadFunc: 'downloadKeyMetrics',
          });
        }}
        gameInfo={gameInfo}
      ></DownloadDialog>
    </>
  );
}

export default connect((state: any) => {
  const { loading, home, opinionCommon, opinionFilter, opinionPerformance } =
    state;

  return {
    userInfoLoading: loading.effects['home/getUserInfo'],
    userInfo: home.userInfo,
    gameInfo: opinionCommon.gameInfo,
    keyMetricsLoading:
      loading.effects['opinionPerformance/getOverviewKeyMetrics'],
    keyMetrics: opinionPerformance.keyMetrics,
  };
})(Metrics);
